// extracted by mini-css-extract-plugin
export var transparent = "AppStoreBadge-module--transparent--68d19";
export var wrapper = "AppStoreBadge-module--wrapper--acf4b";